import Button from "./Button";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default Button;
